// deepanshu_code

import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AdminModal from "./AdminModal";
import api from "../../../utils/api";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { AuthContext } from "../../../context/Authcontext";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const base_url = process.env.REACT_APP_API_URL;

const AdminUsers = () => {
  const navigate = useNavigate();
  const [activeList, setActiveList] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  const [modal, setModal] = useState({ action: null, id: null });
  const [permit, setPermit] = useState([]);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { getRoles } = useContext(AuthContext);
  const [money, setMoney] = useState();
  const [hist, setHist] = useState({});
  const [originalUsers, setOriginalUsers] = useState(); // Store original data
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 100000000; // items per page
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const handleModal = (action, id) => {
    // console.log('dta-id',id, 'action', action);
    setModal({ action: action, id: id });
  };

 const fetchUsers = useCallback(async (pageNumber = 1) => {
  try {
    const auth = localStorage.getItem("admin");

    const response = await api.post(
      "/api/webapi/admin/listMember",
      {
        typeid: "1",
        pageno: pageNumber,
        limit: limit,
        role: "user",
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      }
    );

    setUsers(response.data.datas);
    setOriginalUsers(response.data.datas); // ✅ master copy
    setTotalCount(response.data.datas.length);
  } catch (err) {
    setError(err.message);
  }
}, []);



const filterByDate = () => {
  if (!fromDate && !toDate) {
    setUsers(originalUsers);
    setTotalCount(originalUsers.length);
    return;
  }

  const fromMs = fromDate
    ? new Date(fromDate + "T00:00:00").getTime()
    : null;

  const toMs = toDate
    ? new Date(toDate + "T23:59:59").getTime()
    : null;

  const filtered = originalUsers.filter((u) => {
    const userTime = Number(u.time || u.today);
    if (!userTime) return false;

    if (fromMs && userTime < fromMs) return false;
    if (toMs && userTime > toMs) return false;

    return true;
  });

  setUsers(filtered);
  setTotalCount(filtered.length);
  setPage(1); // ✅ reset pagination
};



  

  const calculatePnLByMarket = (bets, team1, team2) => {
    const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
    const result = {};

    marketTypes?.forEach((market) => {
      // Filter bets for this market type
      const marketBets = bets?.filter((b) => b?.type.toLowerCase() === market);
      const runnerPnl = {};

      // Collect unique runners
      const runners = new Set(marketBets.map(b => b.runnerName));
      runners.add(team1);
      runners.add(team2);
      // Check if runner3 (i.e., "The Draw") exists in sessionStorage
      const runner3 = sessionStorage.getItem("runner3");
      if (runner3 && runner3.toLowerCase() === "the draw") {
        runners.add("The Draw");
      }


      // Initialize PnL
      for (const runner of runners) {
        runnerPnl[runner] = 0;
      }

      // Calculate PnL
      marketBets?.forEach(({ runnerName, side, betprice, betAmount }) => {
        const odds = parseFloat(betprice);
        const stake = parseFloat(betAmount);

        for (const currentRunner of runners) {
          if (currentRunner === runnerName) {
            if (side === "Back") {
              runnerPnl[currentRunner] += (odds - 1) * stake;
            } else if (side === "Lay") {
              runnerPnl[currentRunner] -= (odds - 1) * stake;
            }
          } else {
            if (side === "Back") {
              runnerPnl[currentRunner] -= stake;
            } else if (side === "Lay") {
              runnerPnl[currentRunner] += stake;
            }
          }
        }
      });

      // Round to 2 decimal places
      Object.keys(runnerPnl).forEach((runner) => {
        runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
      });

      // Calculate liability (worst case)
      const liability = Object.values(runnerPnl).length
        ? Math.min(...Object.values(runnerPnl))
        : 0;

      result[market] = {
        pnl: runnerPnl,
        liability: parseFloat(liability.toFixed(2)),
      };
    });

    return result;
  };

  const getUserLiabilityExposure = (user) => {
    let totalLiability = 0;

    // SPORTS: status === 0 only
    const unsettledSports = (user.sports || []).filter(bet => bet.status === 0);
    const groupedSportsBets = {};

    unsettledSports.forEach(bet => {
      const eventId = bet.eventId || "unknown";
      if (!groupedSportsBets[eventId]) groupedSportsBets[eventId] = [];
      groupedSportsBets[eventId].push(bet);
    });

    for (const eventId in groupedSportsBets) {
      const bets = groupedSportsBets[eventId];
      const { team1, team2 } = bets[0] || { team1: "Team 1", team2: "Team 2" };

      const pnlResult = calculatePnLByMarket(bets, team1, team2);

      ["odds", "bookmaker", "mini_bookmaker"].forEach(market => {
        const liab = pnlResult?.[market]?.liability || 0;
        if (liab < 0) totalLiability += liab;
      });
    }

    // FANCY & CASINO: fallback logic → sum betAmount where status === 0
    const unsettledFancy = (user.fancy || []).filter(bet => bet.status === 0);
    const unsettledCasino = (user.casino || []).filter(bet => bet.status === 0);

    const fancyLiability = unsettledFancy.reduce((sum, bet) => sum + parseFloat(bet.betAmount || 0), 0);
    const casinoLiability = unsettledCasino.reduce((sum, bet) => sum + parseFloat(bet.betAmount || 0), 0);

    totalLiability -= fancyLiability;
    totalLiability -= casinoLiability;

    return totalLiability.toFixed(2);
  };


  const fetchHist = useCallback(async (req, res) => {
    const role = localStorage.getItem("role");
    const auth = localStorage.getItem("auth");
    // console.log('roleee',role);

    const respon = await api.post(
       "/api/webapi/admin/chipHistory",
      { role },
      {
        headers: {
          "content-type": "application/json",
          Authorization: `${auth}`,
        },
      }
    );

    // console.log('respp0',respon);
    const data = respon?.data.result;
    // console.log(data);
    if (respon?.data.success) {
      setHist(data[0]);
    }
  }, []);

  const fetchRoles = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);
      let allPermit = [];

      const vall = Object.values(roles[0]);

      const arr = Object.values(vall[0]);

      arr.map((role) => {
        const permis = Object.values(role);

        permis.map((per) => {
          const k = Object.values(per);

          k.map((real) => {
            allPermit.push(real);
          });
        });
      });
      setPermit(allPermit);
    } catch (error) {
      console.log("ert", error);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
    fetchHist();
  }, []);

  useEffect(() => {
    fetchUsers(page);
  }, [fetchUsers, page]);

  const totalPages = Math.ceil(totalCount / limit);

  const handleNext = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  // console.log('perbhyure',permit);

 const handleChange = (e) => {
  const search = e.target.value.toLowerCase();
  setSearchText(search);

  let tempUsers = originalUsers;

  // 🔍 search filter
  if (search) {
    tempUsers = tempUsers.filter(
      (u) =>
        u.username?.toLowerCase().includes(search) ||
        u.createdBy?.toLowerCase().includes(search)
    );
  }

  // 📅 date filter
  if (fromDate || toDate) {
    const fromMs = fromDate
      ? new Date(fromDate + "T00:00:00").getTime()
      : null;
    const toMs = toDate
      ? new Date(toDate + "T23:59:59").getTime()
      : null;

    tempUsers = tempUsers.filter((u) => {
      const t = Number(u.time || u.today);
      if (!t) return false;
      if (fromMs && t < fromMs) return false;
      if (toMs && t > toMs) return false;
      return true;
    });
  }

  setUsers(tempUsers);
  setTotalCount(tempUsers.length);
};


  // fancy lock
  const toggleLockFancy = async (newStatus, userId) => {
    try {
      const response = await api.post(
         "/api/admin/lockFancy",
        { status: newStatus, userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("User Fancy updated successfully");
      } else {
        console.warn("User fancy update failed");
      }
    } catch (error) {
      console.error("Error updating user fancy:", error);
    }
  };

  const toggleLockBet = async (newStatus, userId) => {
    // console.log(userId, newStatus);
    try {
      const response = await api.post(
         "/api/admin/lockBet",
        { status: newStatus, userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("User Fancy updated successfully");
      } else {
        console.warn("User fancy update failed");
      }
    } catch (error) {
      console.error("Error updating user fancy:", error);
    }
  };

  const MySwal = withReactContent(Swal);

  const resetUserButton = async (userId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "This will reset the user’s password to default (123456).",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reset it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.post(
           "/api/admin/resetUserButton",
          {
            userId: userId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          toast.success(response.data.message);
          fetchUsers(page);
        }
      } catch (error) {
        console.error("Error resetting user password:", error);
        toast.error("Something went wrong");
      }
    }
  };

  const toggleLockUser = async (currentStatus, userId) => {
    const newStatus = currentStatus === 1 ? 2 : 1;
    // console.log("Toggling user", userId, "from status", currentStatus, "to", newStatus);

    try {
      const response = await api.post(
         "/api/admin/lockUser",
        { status: newStatus, userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        // console.log("User status updated successfully");
        toast.success("User status updated successfully");
        // Optional: refresh user data here
      } else {
        console.warn("User status update failed");
      }
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };


  const toggleLockBonus = async (currentStatus, userId) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    // console.log("Toggling user", userId, "from status", currentStatus, "to", newStatus);

    try {
      const response = await api.post(
         "/api/admin/lockBonus",
        { status: newStatus, userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        // console.log("Bonus Lockes/Unlocked successfully");
        toast.success("Bonus Lockes/Unlocked successfully");
        // Optional: refresh user data here
      } else {
        console.warn("User Bonus Lock/Unlock failed");
      }
    } catch (error) {
      console.error("Error updating user bonus lock:", error);
    }
  };

  function formateT(params) {
    let result = params < 10 ? "0" + params : params;
    return result;
  }
  function timerJoin(params = "", addHours = 0) {
    let date = "";
    if (params) {
      date = new Date(Number(params));
    } else {
      date = new Date();
    }

    date.setHours(date.getHours() + addHours);

    let years = formateT(date.getFullYear());
    let months = formateT(date.getMonth() + 1);
    let days = formateT(date.getDate());

    let hours = date.getHours() % 12;
    hours = hours === 0 ? 12 : hours;
    let ampm = date.getHours() < 12 ? "AM" : "PM";

    let minutes = formateT(date.getMinutes());
    let seconds = formateT(date.getSeconds());

    return (
      years +
      "-" +
      months +
      "-" +
      days +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      ampm
    );
  }

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) return <p>Loading users...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <div className="wrapper">
        {/* Main Sidebar */}
    

        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: !isMobile && isSidebarOpen ? "" : "0",
            transition: "margin-left 0.3s ease",
          }}
        >
          <div className="side-body padding-top">
            <div className="container-fluid">
              <ul className="nav nav-tabs mobile_responsive user-nav">
                <li
                  className={`${
                    activeList === 0 ? "active1" : ""
                  } cursor-pointer`}
                  onClick={() => setActiveList(0)}
                >
                  <a
                    href="/admin/users"
                    className="active text-black"
                    // style={{ pointerEvents: "none" }}
                  >
                    Users
                  </a>
                </li>
              </ul>
              <div className="d-flex flex-wrap justify-content-between me-3">
                <h1 className="page-title">
                  <i className="sidebar-mini-person" /> Users
                </h1>
                <div className="d-flex gap-2 pull-right topright_buttons">
                  <Link
                    href="##"
                    className={`btn btn-success getsportsetting red_btn ${
                      permit.includes("Add Admin") ? "d-block" : "d-none"
                    }`}
                    onClick={(e) => {
                      e.preventDefault(); // ✅ Prevents reload
                      handleModal("add-admin", null); // ✅ Triggers modal
                    }}
                  >
                    <i className="fa fa-plus" />
                    Add Admin
                  </Link>
                  <Link
                    title="A/c Chips In/Out"
                    href="##"
                    className={`btn btn-sm btn-info color-1 ${
                      permit.includes("A/C chips In/Out") ? "d-block" : "d-none"
                    }`}
                    onClick={(e) => {
                      e.preventDefault(); // ✅ Prevents reload
                      handleModal("chips-in-out", null); // ✅ Triggers modal
                    }}
                  >
                    A/c Chips In/Out [Super Admin]
                  </Link>
                  {/* <Link href="#" className="btn btn-danger getbalancesheet">
                    <i className="fa fa-file" /> Export
                  </Link> */}
                </div>
              </div>
            </div>
            <div id="sidebar-mini-notifications" />
            <div className="page-content browse container-fluid">
              <div className="alerts"></div>
              <div className="row me-0">
                <div className="col-md-12 oneonofftab">
                  <div className="panel panel-bordered sportsNew">
                    {/* <div className="panel-body">
                      <table className="table table-hover dataTableuser table-responsive user-outer">
                      <thead>
                      <tr>
                        <th>Available Balance</th>
                        <th>Amount</th>
                        <th>Debit/Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{money}</td>
                        <td>{hist?.amount}</td>
                        <td>{hist?.type}</td>
                      </tr>

                    </tbody>
                      </table>
                     
                    </div> */}

                    <div className="relative p-2 max-w-sm mx-auto">
                      <input
                        type="text"
                        placeholder="🔍 Search by username or invite..."
                        onChange={(e) => handleChange(e)}
                        className="w-100 px-4 py-2 pl-10 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div className="flex flex-row gap-2 p-2 max-w-md mx-auto">
                      <input
                        type="date"
                        onChange={(e) => setFromDate(e.target.value)}
                        className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm"
                      />
                      <input
                        type="date"
                        onChange={(e) => setToDate(e.target.value)}
                        className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm"
                      />
                <button
  onClick={filterByDate}
  className="px-4 py-2 bg-blue-500 text-black rounded-lg"
>
  Filter
</button>


                      <button className="px-4 py-2 text-success border-success   rounded-lg">
                        Total Users {totalCount}
                      </button>
                    </div>

                    <div className="dataTable mt-5 table-responsive">
                      <table
                        id="dataTable"
                        className="table table-hover dataTableuser table-responsive-sm user-outer"
                      >
                        <thead className="text-nowrap">
                          <tr>
                            <th className="table-bg">
                              <Link href="#">ID</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">User Name</Link>
                            </th>
                            {/* <th className="table-bg">
                              <Link href="#">Mobile Number</Link>
                            </th> */}
                            {/* <th className="table-bg">
                              <Link href="#">Password</Link>
                            </th> */}
                            <th className="table-bg">
                              <Link href="#">Role</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Main Balance</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Exp</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Bonus</Link>
                            </th>
                            {/* <th className="table-bg">
                              <Link href="#">Commission%</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">EXP</Link>
                            </th> */}
                            {/* <th className="table-bg">
                              <Link href="#">Given Commission%</Link>
                            </th> */}
                            {/* <th className="table-bg">
                              <Link href="#"> Settlment Amount</Link>
                            </th> */}
                            <th className="table-bg">
                              <Link href="#">Fancy Locked</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Betting Locked</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">User Locked</Link>
                            </th>
                            {/* <th className="table-bg">
                              <Link href="#">Bonus Locked</Link>
                            </th> */}
                            <th className="table-bg">
                              <Link href="#">Created by</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">self code </Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Created</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Profit Loss</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Created At</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Options</Link>
                            </th>
                            <th
                              className={`table-bg ${
                                permit.includes("View More/Edit")
                                  ? ""
                                  : "d-none"
                              }`}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="admindata">
                          {users?.map(
                            (data) =>{
                              if(data.role === "user"){
                                const exposure = getUserLiabilityExposure(data)
                                

                                return (
                                  <tr key={data.id}>
                                    <td className="pdl0pdr0 border">
                                      <span>{data.id}</span>
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      <Link
                                        href="#"
                                        title="View Child User"
                                        style={{ color: "#000" }}
                                      >
                                        {data.username}
                                      </Link>
                                    </td>
                                    {/* <td className="pdl0pdr0 border">
                                      <span>{data.phone}</span>
                                    </td> */}
                                    {/* <td className="pdl0pdr0 border">
                                      <span>{data.plain_password}</span>
                                    </td> */}
                                    <td className="pdl0pdr0 border">
                                      <span>{data.role}</span>
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      {data.money}
                                    </td>
                                    <td className="pdl0pdr0 border cursor-pointer" onClick={()=>navigate(`/admin/exposure/${data.phone}`)}>
                                      {exposure || 0}
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      <span className="green">
                                        {data.bonus_money}
                                      </span>
                                    </td>
                                    {/* <td className="pdl0pdr0 border">
                                      <span className="green">{data.commission}</span>
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      <span className="green">{data.givecommission}</span>
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      <span className="green">0.00</span>
                                    </td> */}
                                    <td className="pdl0pdr0 border text-center px-3">
                                      <div className="form-row customtoggle">
                                        <div
                                          className="form-group"
                                          style={{ position: "relative" }}
                                        >
                                          <label
                                            htmlFor="lockuser"
                                            title="Self Lock"
                                          >
                                            {" "}
                                            Fancy Lock
                                          </label>
                                          <div className="toggle_bx">
                                            <label className="switch">
                                              <input
                                                type="checkbox"
                                                name="lock_fancy_betting"
                                                id={data.id_user}
                                                value="1"
                                                defaultChecked={
                                                  data.fancylocked === 2
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;
                                                  const newStatus = isChecked
                                                    ? 2
                                                    : 1;
                                                  toggleLockFancy(
                                                    newStatus,
                                                    data.id_user
                                                  );
                                                }}
                                              />
                                              <div className="slider round extratoggle" />
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="pdl0pdr0 border text-center px-3">
                                      <div className="form-row customtoggle">
                                        <div
                                          className="form-group"
                                          style={{ position: "relative" }}
                                        >
                                          <label
                                            htmlFor="lockuser"
                                            title="Self Lock"
                                          >
                                            {" "}
                                            Bet Lock
                                          </label>
                                          <div className="toggle_bx">
                                            <label className="switch">
                                              <input
                                                type="checkbox"
                                                name="lock_betting"
                                                id={data.id_user}
                                                value="1"
                                                defaultChecked={
                                                  data.betlock === 1
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;
                                                  const newStatus = isChecked
                                                    ? 1
                                                    : 0;
                                                  toggleLockBet(
                                                    newStatus,
                                                    data.id_user
                                                  );
                                                }}
                                              />
                                              <div className="slider round extratoggle" />
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      <div className="form-row customtoggle">
                                        <div
                                          className="form-group"
                                          style={{ position: "relative" }}
                                        >
                                          <label
                                            htmlFor="lockuser"
                                            title="Self Lock"
                                          >
                                            {" "}
                                            Self Lock
                                          </label>
                                          <div className="toggle_bx">
                                            <label className="switch">
                                              <input
                                                type="checkbox"
                                                name="close_account"
                                                id={data.id_user}
                                                value="1"
                                                defaultChecked={data.status === 2}
                                                onChange={() =>
                                                  toggleLockUser(
                                                    data.status,
                                                    data.id_user
                                                  )
                                                }
                                              />
                                              <div className="slider round extratoggle" />
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    {/* <td className="pdl0pdr0 border">
                                      <div className="form-row customtoggle">
                                        <div
                                          className="form-group"
                                          style={{ position: "relative" }}
                                        >
                                          <label
                                            htmlFor="lockuser"
                                            title="Self Lock"
                                          >
                                            {" "}
                                            Bonus Lock
                                          </label>
                                          <div className="toggle_bx">
                                            <label className="switch">
                                              <input
                                                type="checkbox"
                                                name="close_account"
                                                id={data.id_user}
                                                value="1"
                                                defaultChecked={data.bonusLock === 0}
                                                onChange={() =>
                                                  toggleLockBonus(
                                                    data.bonusLock,
                                                    data.id_user
                                                  )
                                                }
                                              />
                                              <div className="slider round extratoggle" />
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </td> */}
                                    <td className="pdl0pdr0 border">
                                      {data.createdBy}
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      {data.code}
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      {data.create_status === 1
                                        ? "Sign Up"
                                        : "Admin Panel"}
                                    </td>
                                    <td
                                      className={`pdl0pdr0 border ${
                                        parseFloat(data.totalProfit) -
                                          parseFloat(data.totalLoss) >
                                        0
                                          ? "text-green"
                                          : "text-red"
                                      }`}
                                    >
                                      {(
                                        parseFloat(data.totalProfit) -
                                        parseFloat(data.totalLoss)
                                      ).toFixed(2)}
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      {timerJoin(data.time)}
                                    </td>
                                    <td className="pdl0pdr0 border">
                                      <div className="d-flex gap-1 ">
                                        <Link
                                          to={`/admin/userSetting/${data.phone}`}
                                          title="Setting"
                                          className="optionsBtn"
                                        >
                                          S
                                        </Link>
                                        <Link
                                          to={`/admin/userBetHistory/${data.phone}`}
                                          title="Bet History"
                                          className="optionsBtn"
                                        >
                                          BH
                                        </Link>
                                        <Link
                                          to={`/admin/userSportsSetting/${data.phone}`}
                                          title="Sports Setting"
                                          className="optionsBtn"
                                        >
                                          SS
                                        </Link>
                                        <Link
                                          to={`/admin/userStatement/${data.id}`}
                                          title="Account Statement"
                                          className="optionsBtn"
                                        >
                                          AS
                                        </Link>
                                        <Link
                                          to={`/admin/userWeeklyReport/${data.phone}`}
                                          title="Weekly Report User"
                                          className="optionsBtn"
                                        >
                                          WR
                                        </Link>
                                        <Link
                                          onClick={() =>
                                            resetUserButton(data.phone)
                                          }
                                          title="Reset Password Button"
                                          className="optionsBtn bg-danger"
                                        >
                                          P
                                        </Link>

                                        {/* <Link to={`/admin/userSetting/${data.phone}`} title="Casino Setting" className="optionsBtn">CS</Link>
                                        <Link to={`/admin/userSetting/${data.phone}`} title="I Casino Setting" className="optionsBtn">ICS</Link> */}
                                      </div>
                                    </td>
                                    <td
                                      className={`  no-sort no-click ${
                                        permit.includes("View More/Edit")
                                          ? ""
                                          : "d-none"
                                      }`}
                                      id="bread-actions"
                                    >
                                      <span className="dropdown user-more-btn">
                                        <Link
                                          href="#"
                                          className="btn btn-xs btn-success"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleModal("user-show", data.id);
                                          }}
                                        >
                                          View More <span className="caret" />
                                        </Link>
                                      </span>
                                    </td>
                                  </tr>
                                )
                              }
                          })}
                        </tbody>
                      </table>

                      
                    </div>
                    <div className="pagination-controls mt-3 d-flex justify-content-between align-items-center">
                        <button
                          className="btn-info border-0 p-2 rounded"
                          onClick={handlePrev}
                          disabled={page === 1}
                        >
                          Previous
                        </button>
                        <span>
                          Page {page} of {totalPages || 1}
                        </span>
                        <button
                          className="btn-info border-0 p-2 rounded"
                          onClick={handleNext}
                          disabled={page === totalPages}
                        >
                          Next
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminModal modal={modal} setModal={setModal} data={users} />
        {
          <div
            id="overlayId"
            className={`overlay ${modal?.action ? "d-block" : "d-none"}`}
          ></div>
        }
      </div>
    </>
  );
};
export default AdminUsers;